import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@hivewatch/dark'

interface UnsavedChangesModalIProps {
  colorScheme: 'light' | 'dark'
  isOpen: boolean
  isSaving: boolean
  onDiscard: () => void
  onKeepEditing: () => void
  onSave: () => void
}

export const UnsavedChangesModal = ({
  colorScheme,
  isOpen,
  isSaving,
  onDiscard,
  onKeepEditing,
  onSave,
}: UnsavedChangesModalIProps) => {
  const { t } = useTranslation()

  return (
    <Modal
      closeOnEsc={false}
      closeOnOverlayClick={false}
      colorScheme={colorScheme}
      footer={
        <>
          <Button
            colorScheme={colorScheme}
            disabled={isSaving}
            onClick={onKeepEditing}
            variant='tertiary'
          >
            {t('settings:rebrand_keep_editing')}
          </Button>
          <Button
            colorScheme={colorScheme}
            disabled={isSaving}
            onClick={onDiscard}
            variant='secondary'
          >
            {t('settings:rebrand_discard_changes')}
          </Button>
        </>
      }
      isCloseHidden={isSaving}
      isOpen={isOpen}
      isSaveLoading={isSaving}
      onClose={onKeepEditing}
      onSave={onSave}
      saveButtonLabel={t('settings:rebrand_save_changes')}
      size='compact'
      title={t('settings:rebrand_unsaved_changes_title')}
    >
      <Text textStyle='body'>
        {t('settings:rebrand_unsaved_changes_description')}
      </Text>
    </Modal>
  )
}
